<template>
  <div class="workOrder" ref="workOrder">
    <div class="workOrderBg"></div>
    <ul class="workOrderFont">
      <li>
        <div class="li_title">闭环管理当日发生</div>
        <div class="li_num">{{ dataObj.totalCount }}</div>
      </li>
      <li>
        <div class="li_title">闭环管理当日处理</div>
        <div class="li_num">{{ dataObj.finishedCount }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['matrix', 'x', 'y'],
  data() {
    return {
      pageInfo: 'workOrder.vue',
      computedName: '闭环管理组件',
      customerId: this.$store.state.customerId,
      dataObj: {},
      setTime1: null
    }
  },
  mounted() {
    let that = this
    let w = $(that.$refs.workOrder).outerWidth()
    let h = $(that.$refs.workOrder).outerHeight()
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y
    })
    this.getListData()
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1)
      this.setTime1 = null
    }
  },
  methods: {
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1)
        this.setTime1 = null
      }
      let getWorkTicketStatistics = CONFIG.requestName + this.$apiOpt.getWorkTicketStatistics
      let res = await this.$apiUtils.get(getWorkTicketStatistics, {
        customerId: this.customerId
      })
      if (res) {
        this.dataObj = res
      }
      const time = this.customerId == 46 ? 5 * 1000 * 60 : 60 * 1000 * 60
      this.setTime1 = setTimeout(() => {
        this.getListData()
      }, time)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.workOrder {
  height: 250px;
  width: 600px;
  .workOrderBg {
    @include bg-box(560px, 178px, 'workOrderBg.png');
    margin-top: 32px;
    position: absolute;
  }
  ul {
    height: 178px;
    margin-top: 32px;
    li {
      height: 50%;
      display: flex;
      .li_title {
        z-index: 2;
        flex: 350;
        line-height: 89px;
        text-align: center;
        font-size: 36px !important;
        color: #ffffff;
        text-shadow: 8px 8px 8px rgba(255, 255, 255, 0.5);
      }
      .li_num {
        z-index: 2;
        flex: 210;
        line-height: 89px;
        text-align: center;
        width: 68px;
        font-size: 46px;
        color: #f5a623;
        text-shadow: 8px 8px 8px rgba(245, 166, 35, 0.32);
      }
    }
    li:nth-child(2) {
      .li_num {
        color: #30d594;
        text-shadow: 8px 8px 8px rgba(35, 245, 158, 0.32);
      }
    }
  }
}
</style>
